import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 5, y: 5, width: 6, height: 6, rx: 3, fill: "currentColor" }));
export default SvgDot;
